module.exports = __webpack_public_path__ + "img/ucreagent.da1d7141.webp";